<template>
  <div class="admin">
    <el-container direction="vertical">
      <el-header :height="`${headerHeight}px`" class="admin__header fn-clear">
        <div class="admin__header-left">
          <img src="@/assets/images/logo.png" />
        </div>
        <div class="admin__header-right">
          <span>{{ loginBackDate }}</span>
          <el-button
            type="info"
            icon="el-icon-switch-button"
            circle
            @click="handleLogOut"
          ></el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside
          class="admin__aside"
          width="200px"
          :style="`min-height:${asideHeight}px;`"
        >
          <el-menu
            :default-active="menuIndex"
            class="admin__aside-menu"
            background-color="#304156"
            text-color="#ffffff"
            active-text-color="#1977ff"
            @select="handleMenu"
          >
            <el-submenu index="创业导师服务管理">
              <template slot="title">
                <span>创业导师服务管理</span>
              </template>
              <el-menu-item index="创业导师管理">创业导师管理</el-menu-item>
              <el-menu-item index="导师咨询管理">导师咨询管理</el-menu-item>
            </el-submenu>
            <el-submenu index="推广服务管理">
              <template slot="title">
                <span>推广服务管理</span>
              </template>
              <el-menu-item index="优质企业管理">优质企业管理</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      loginBackDate: "",
      headerHeight: 80,
      menuIndex: "",
      menuList: [
        {
          name: "创业导师管理",
          url: "/admin/mentorManage/teacherList",
          reg: /teacher/
        },
        {
          name: "导师咨询管理",
          url: "/admin/mentorManage/counselList",
          reg: /counsel/
        },
        {
          name: "优质企业管理",
          url: "/admin/mentorManage/companyList",
          reg: /company/
        }
      ]
    };
  },
  computed: {
    asideHeight() {
      return window.innerHeight - this.headerHeight;
    }
  },
  watch: {
    $route: "showMenu"
  },
  created() {
    const time = this.$cookies.get("loginBackDate");
    this.loginBackDate = time ? `登录时间： ${time}` : "";
    this.showMenu();
  },
  methods: {
    handleLogOut() {
      this.$cookies.remove("backToken");
      this.$cookies.remove("loginBackDate");
      this.redirectByPath("/");
    },
    showMenu() {
      this.menuList.some((item) => {
        var bool = item.reg.test(this.$route.path);
        if (bool) {
          this.menuIndex = item.name;
          return true;
        }
      });
    },
    handleMenu(index) {
      this.menuIndex = index;
      this.menuList.some((item) => {
        var bool = item.name === index;
        if (bool) {
          this.redirectByPath(item.url);
          return true;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.admin {
  // header
  .admin__header {
    line-height: 80px;
    font-size: 14px;
    color: #ffffff;
    background: rgb(48, 65, 86);
    .admin__header-left {
      float: left;
      padding-top: 15px;
      margin-right: 20px;
    }
    .admin__header-right {
      float: right;
      span {
        padding-right: 20px;
      }
    }
  }
  // aside
  .admin__aside {
    font-size: 16px;
    color: #b6c6d5;
    background: rgb(48, 65, 86);
    /deep/ .admin__aside-menu {
      border-right: none;
      .el-menu-item,
      .el-submenu__title {
        i {
          color: inherit;
        }
      }
    }
  }
}
</style>
